// iTHNK strings, merged after the upstream CRM messages (English; other locales fall back to it).
export const ithnkMessages = {
  resources: {
    sales: {
      fields: { role: "Role" },
      roles: { admin: "Admin", sales: "Sales", delivery: "Delivery" },
    },
    deliveries: {
      name: "Delivery |||| Deliveries",
      fields: {
        title: "Title",
        deal_id: "Deal",
        company_id: "Company",
        contact_id: "Contact",
        address: "Address",
        due_date: "Due date",
        phase: "Phase",
        current_position: "Milestone",
        delivered_at: "Delivered at",
        assigned_sales_id: "Assigned to",
        notes: "Notes",
      },
      phases: {
        not_started: "Not started",
        in_progress: "In progress",
        completed: "Completed",
      },
      all: "All",
      milestones: "Milestones",
      add_milestone: "Add milestone",
      save_milestones: "Save milestones",
      upcoming: "My upcoming deliveries",
    },
    notes: {
      intent: {
        set: "Intent",
        clear: "Clear the intent",
        by_ai:
          "Labelled by AI from the forwarded reply; pick another to correct it",
        values: {
          interested: "Interested",
          question: "Question",
          not_now: "Not now",
          not_interested: "Not interested",
          out_of_office: "Out of office",
          unsubscribe: "Unsubscribe",
        },
      },
    },
    contacts: {
      fields: { hot_since: "Hot since" },
    },
    companies: {
      fields: { fit_score: "Fit score" },
      autofill: {
        fill_in: "Fill in details",
        reading: "Looking it up…",
        help: "Finds the company's website from its name (or reads the website typed in) and suggests details and a logo; nothing changes until you accept",
        pick: "Which website is it? Only sites that name the company are shown.",
        no_match:
          "No website found that names this company; type its website and try again",
        need_name: "Type the company's name or website first",
        accept: "Accept",
        accept_all: "Accept all (%{smart_count})",
        suggested: "Suggested:",
        nothing: "The website gave nothing new to fill in",
        failed: "Could not fill in: %{error}",
      },
    },
    fit: {
      title: "Fit",
      badge: "Fit %{score}/5",
      matches: { 1: "Weak match", 2: "Partial match", 3: "Strong match" },
      action: "Score fit",
      scoring: "Scoring…",
      failed: "Could not score the fit. Try again.",
      profile: "Ideal customer profile",
      profiles: "Ideal customers",
      profiles_help:
        "Describe who buys from THNK. The Score fit button on a company or contact rates each signal 0 to 5 with a one-line reason.",
      one_per_line: "One per line",
      filter: "Fit",
      not_scored: "Not scored",
      profile_fields: {
        name: "Profile name",
        offer: "What we sell",
        customer_problem: "The customer's problem",
        target_role: "Target role",
        target_geography: "Target geography",
        target_company_size: "Target company size",
        positive_criteria: "Good-fit signals",
        negative_criteria: "Bad-fit signals",
        example_clients: "Example clients",
      },
    },
    pre_leads: {
      name: "Pre-lead |||| Pre-leads",
      nav: "Generate",
      title: "Pre-leads",
      empty:
        "No pre-leads yet. Find pre-leads runs the agent; Add by hand adds one company.",
      add_found: "Add to pre-leads |||| Add %{smart_count} to pre-leads",
      find: "Find pre-leads",
      add_by_hand: "Add by hand",
      search_by_filters: "Search by filters",
      search: "Search company or person",
      segment_all: "Segment: all",
      contact_all: "Contact: all",
      contact_with: "With a contact",
      contact_without: "Without a contact (needs one)",
      segment_results: {
        title: "Segment results",
        empty:
          "No segment results yet. They appear once a search on Find leads has pre-leads to count.",
        help: "What each segment's pre-leads came to, with the agent's suggestion. Nothing changes until Apply: Scaling searches one more page of each engine for the segment, Paused stops both the lead agent and the nightly run searching it.",
        segment: "Segment",
        suggestion: "Suggestion",
        counts: {
          found: "Found",
          kept: "Kept",
          removed: "Not a fit",
          sent: "Sent",
          replied: "Replies",
          interested: "Interested",
          converted: "Deals",
        },
        labels: {
          scaling: "Scaling",
          working: "Working",
          paused: "Paused",
          too_early: "Too early",
        },
        apply: "Apply",
        dismiss: "Dismiss",
        apply_segment: "Apply the suggestion for %{segment}",
        dismiss_segment: "Dismiss the suggestion for %{segment}",
        is_paused: "paused",
        weight: "%{weight} pages",
      },
      fields: {
        company_name: "Company",
        contact_email: "Write to",
        fit: "Fit",
        why_now: "Why now",
        status: "Status",
        next_touch_at: "Next",
        website: "Website",
        contact_first_name: "First name",
        contact_last_name: "Last name",
        contact_title: "Title",
      },
      statuses: {
        found: "To review",
        kept: "Kept · drafting",
        ready: "Ready to send",
        approved: "Approved",
        sent: "Sent · waiting",
        replied: "Replied",
        converted: "Converted",
        closed: "Closed",
      },
      tag: {
        sent: "Sent · touch %{touch} of %{max}",
        replied: "Replied · %{intent}",
      },
      needs_reply: "a reply is waiting",
      last_night:
        "Last night: %{found} found, %{drafted} drafted, %{sent} sent or queued",
      last_night_running:
        "Tonight's run: %{found} found, %{drafted} drafted so far",
      none_found: "none found",
      next: {
        found: "Keep or remove",
        kept: "Finding contacts…",
        ready: "Approve draft",
        approved: "Sends %{date}",
        approved_soon: "Sends soon",
        sent: "Follow-up %{date}",
        waiting: "Waiting",
        replied: "Reply today",
        converted: "In Deals",
      },
      closed_reasons: {
        removed: "Removed",
        not_interested: "Not interested",
        unsubscribed: "Unsubscribed",
        bounced: "Bounced",
        no_reply: "No reply",
        not_hot: "Not a hot lead",
        duplicate: "Duplicate",
      },
      bulk: {
        keep: "Keep",
        remove: "Remove…",
        draft: "Draft emails",
        approve: "Approve & send",
      },
      remove_title:
        "Remove %{smart_count} pre-lead |||| Remove %{smart_count} pre-leads",
      remove_reason: "Why not a fit? (optional, teaches the next runs)",
      settings: {
        title: "Outreach",
        help: "How the server writes to pre-leads: how often, when, and how it signs off.",
        max_touches: "Emails per pre-lead (1 to 3)",
        max_touches_help: "The first email counts, so 3 means two follow-ups.",
        followup_days: "Follow-up after (days)",
        followup_days_help:
          "Days after the previous email, separated by commas: 4, 7",
        send_days: "Send on",
        send_days_help: "Emails only go out on these days.",
        send_hours: "Send between",
        send_hours_help: "24-hour window, start-end: 09:00-16:00",
        timezone: "Timezone",
        timezone_help:
          "The window above is read in this timezone, e.g. Africa/Cairo.",
        daily_cap: "Emails per day (at most)",
        daily_cap_help:
          "Whole number; sending stops for the day at this count.",
        send_hours_invalid: "Use the form 09:00-16:00",
        timezone_invalid: "Not a known timezone, e.g. Africa/Cairo",
        opt_out_line: "Opt-out line",
        opt_out_line_help: "Added at the end of every email.",
        booking_url: "Booking link",
        booking_url_help:
          "Where a prospect books a call. Suggest reply offers it when the reply is interested; leave empty for none.",
        booking_url_invalid: "Use an https:// link",
        last_poll: "Server last checked the mailboxes at %{time}",
        never_polled: "Never checked yet",
        poll_errors: "(%{smart_count} error) |||| (%{smart_count} errors)",
        days: {
          sunday: "Sunday",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
        },
      },
      add_title: "Add a pre-lead by hand",
      close: "Close",
      widen: "Widen panel",
      narrow: "Narrow panel",
      drawer: {
        tabs: { evidence: "Evidence", draft: "Draft", thread: "Thread" },
        criteria: "Criteria",
        ruled_out: "Ruled out",
        none: "none",
        why: "Why it fits",
        why_now: "Why now",
        write_to: "Write to",
        nobody: "Nobody found yet",
        add_contact: "Add a contact",
        change_contact: "Change the contact",
        save_contact: "Save the contact",
        contact_saved: "Contact saved. Press Keep to draft to this person.",
        contact_fields: {
          contact_first_name: "First name",
          contact_last_name: "Last name",
          contact_title: "Title",
          contact_email: "Email",
        },
        from: "from %{mailbox}",
        site: "Website",
        news: "News",
        signals: {
          job: "Job ads",
          tender: "Tenders",
          regulation: "Regulator",
          report: "Annual report",
        },
        people: "People found",
        write_to_person: "Write to this person",
        locked: "Fixed once the first email is approved",
        resume: "Resume follow-ups",
        touch: "Touch %{touch}",
        sends: "Sends %{date}",
        sent: "Sent %{date}",
        subject: "Subject",
        body: "Email",
        attach: "Attach",
        save: "Save",
        personalise: "Personalise",
        delete_followup: "Delete this follow-up",
        no_draft:
          "No draft yet: Keep finds the people and drafts the first email.",
        message_status: {
          draft: "Draft",
          queued: "Queued",
          sent: "Sent",
          failed: "Failed",
          received: "Received",
        },
        no_thread: "Nothing sent yet",
        ai_read: "AI read this as %{intent}",
        change_intent: "Change the intent",
        confirm_intent: "Relabel this reply as %{intent}?",
        confirm_intent_help:
          "The pre-lead is closed and the address goes on the do-not-contact list.",
        reply_from: "Reply from %{mailbox}",
        reply: "Reply",
        suggest: "Suggest reply",
        send_reply: "Send reply",
        not_hot: "Not a hot lead",
        snooze: "Snooze 3 days",
        convert: "Convert to lead",
        convert_help:
          "Convert creates the company, the contact and a deal, and copies this thread to the deal's notes.",
        notify: {
          saved: "Draft saved",
          reply_sent: "Reply sent",
          snoozed: "Snoozed for 3 days",
          not_hot: "Closed as not a hot lead",
          writing_to: "Now writing to %{name}",
          resumed: "Follow-ups resume %{date}",
        },
      },
      notify: {
        added: "%{added} added, %{skipped} skipped",
        created: "Pre-lead added",
        ready: "%{name}: draft ready",
        kept: "%{name}: %{error}",
        no_why_now: "%{name}: removed, no why-now fact in its news",
        removed: "%{smart_count} removed",
        sent: "%{name}: sent",
        queued: "%{name}: queued until %{date}",
        failed: "%{name}: %{error}",
      },
    },
    leads: {
      title: "Find leads",
      nav: "Leads",
      describe: "Describe the ideal customer",
      describe_placeholder:
        "For example: restaurant and bakery chains in Cairo with 50 to 500 staff; we talk to the operations director",
      suggest: "Suggest filters",
      use_profile: "Use the %{name} profile",
      add_chip: "Type and press Enter",
      filters: {
        keywords: "Keywords",
        job_titles: "Job titles",
        locations: "Locations",
        employees: "Employees",
      },
      engine: "Search engine",
      search: "Search",
      searching_maps: "Searching Google Maps (a minute or two)…",
      still_running:
        "The map search is still running; search again in a minute",
      no_key:
        "No key for this engine yet: an admin adds it in Settings, Lead engines",
      excluded:
        "Nobody left out |||| %{smart_count} left out: already in the CRM or on the do-not-contact list",
      next_page: "Next page (uses a look-up)",
      add: "Add as leads |||| Add %{smart_count} as leads",
      added:
        "%{smart_count} lead added (%{skipped} skipped) |||| %{smart_count} leads added (%{skipped} skipped)",
      columns: {
        company: "Company",
        contact: "Contact",
        where: "Where",
        fit: "Fit",
      },
      engines: {
        title: "Lead engines",
        help: "Paste each engine's API key once. Keys are kept on the server and are never shown again; searches stop at the daily limit per engine.",
        daily_cap: "Look-ups per engine per day",
        daily_cap_help:
          "Each search page or map search is one look-up (default 50)",
        set: "Key set %{date}",
        not_set: "No key",
        paste: "Paste the %{engine} API key",
        saved: "Lead engine key saved",
        apollo_people: "Apollo: people",
        apollo_companies: "Apollo: companies",
        apify_maps: "Google Maps (Apify)",
        wikidata_orgs: "Wikidata (free)",
      },
      contacts: {
        title: "Lead email",
        find: "Find contacts",
        personalise: "Personalise",
        personalise_help:
          "Picks the best person on this deal (IT and digital chiefs first, then the CEO, other chiefs, directors; a shared inbox last), greets them by name, sends to senior people from you personally, signs as the sender and saves it as the deal's draft",
        personalised:
          "Draft addressed to %{name} (%{title}), from %{from}, saved on the deal",
        no_recipient:
          "No contact with an email on this deal yet: click Find contacts first",
        find_help:
          "Reads the company's website, then searches its decision-makers with verified emails (Apify, about $0.003 a person, a minute or two)",
        no_website:
          "Add the company's website first: Find contacts reads the addresses it publishes",
        found:
          "%{found} addresses found, %{smart_count} new contact added (%{suppressed} on the do-not-contact list) |||| %{found} addresses found, %{smart_count} new contacts added (%{suppressed} on the do-not-contact list)",
        no_draft:
          "No drafted email on this deal yet: draft one from Leads, Find leads for me, or add a note starting DRAFT EMAIL.",
        no_outlook:
          "Sending needs Outlook: an admin adds the Microsoft app ID in Settings, Lead agent.",
      },
      agent: {
        title: "Find leads for me",
        help: "The AI reads %{website} and the won deals, works out who needs this work, searches every lead engine that has a key and ranks what it finds. Nothing is saved or sent until you choose.",
        run: "Find leads for me",
        review:
          "Review the segments: untick the ones to skip, edit the criteria, then Search. Every lead is scored against its segment's criteria.",
        search:
          "Search %{smart_count} segment |||| Search %{smart_count} segments",
        reading_sites:
          "Reading the website and recent news of %{smart_count} candidate for %{segment}… |||| Reading the websites and recent news of the %{smart_count} best candidates for %{segment}…",
        site_checked: "checked on its website and in the news",
        why_now: "Why now: %{fact}",
        rank_failed:
          "Scoring a batch failed (%{error}); its leads are shown unscored",
        not_fit: "Not a fit",
        not_fit_why: "Why not? (teaches the next runs)",
        not_fit_confirm: "Reject",
        rejected: "Rejected: the next runs will avoid leads like it",
        brief: {
          name: "Segment",
          problem: "Their problem",
          why: "Why they buy",
          positive: "A good lead (one criterion per line, scored 0-5)",
          negative: "Rules a lead out (one per line)",
          role: "Write to",
          examples: "Ideal clients like (comma separated)",
          keywords: "Map search words (the buyer's kind of place)",
          locations: "Locations (separated by ;)",
        },
        focus: "Focus (optional)",
        focus_placeholder:
          "Focus (optional), for example: licensed fintechs in Egypt, GCC government bodies, private hospitals in Cairo",
        no_keys:
          "No lead engine has a key yet: an admin adds one in Settings, Lead engines",
        reading: "Reading %{website}…",
        customers:
          "Learning from %{smart_count} won customer |||| Learning from %{smart_count} won customers",
        searching: "Searching %{segment} on %{engine}…",
        no_engine: "%{segment}: no engine with a key can search this segment",
        not_buyers:
          "Left out %{smart_count} result that does not buy consultancy (a tech firm, association, shop or branch) |||| Left out %{smart_count} results that do not buy consultancy (tech firms, associations, shops, branches)",
        done: "%{smart_count} lead found |||| %{smart_count} leads found",
        offer: "What we sell:",
        draft: "Draft email",
        subject: "Subject",
        body: "Email",
        attach: "Attach:",
        copy: "Copy",
        copied: "Email copied",
        open_mail: "Open in mail app",
        to: "To",
        send: "Send from Outlook",
        from: "From",
        senders: {
          sales: "Sales (%{address})",
          personal: "Me personally (%{name})",
        },
        bcc: "BCC %{address}, so the team sees it",
        default_from: "Default sender",
        signature_personal: "Signature, sent personally",
        signature_sales: "Signature, sent as sales",
        signature_help:
          "Personalise puts it under the email; {name} is the signed-in user. Empty uses the default shown.",
        default_from_help:
          "Emails to C-level and senior managers (CEO, director, head of, VP, minister…) go from the user personally whatever the default; each email can still be changed.",
        sent: "Email sent to %{to}",
        outlook_title: "Outlook",
        outlook_help:
          "Lead emails go out from the signed-in user's Outlook, shown as from the address below and BCC'd to it. The user needs Send As rights on that address.",
        outlook_client_id: "Microsoft app (client) ID",
        outlook_client_id_help:
          "Entra app registration, single-page app, redirect https://crm.ithnk.com/outlook.html, permission Mail.Send",
        outlook_send_as: "Send as",
        settings_title: "Lead agent",
        night: {
          title: "Nightly run",
          plan: "Searches the segments last searched here: %{segments}. The run never changes them.",
          no_plan:
            "No segments saved yet: run Find leads and Search once, and the nightly run uses those segments.",
          find: "Find leads every night",
          find_help:
            "From 00:05 UTC, when the free AI allowance resets, the agent searches the saved segments within the daily look-ups, ranks what it finds and drafts a first email per new pre-lead.",
          send: "Send first emails alone",
          send_help:
            "Off: the drafts wait in Ready to send for review. On: the agent approves them itself, up to Emails per day, sent in the send window. Replies always come to people.",
        },
        our_website: "Our website",
        our_website_help:
          "The agent reads it to learn what we sell (ithnk.com when empty)",
        brochures: "Brochures",
        brochures_help:
          "Each draft attaches only the ones that fit the lead (at most two, 2.8 MB together; the rest go as links). Give each a name, an https link and what it covers and for which lead: the agent picks by that.",
        brochure_name: "Name",
        brochure_url: "Link (https)",
        brochure_about: "What it covers",
      },
    },
    contracts: {
      title: "Contracts and proposals",
      upload: "Upload contract",
      empty:
        "No contract yet. Upload the signed contract or proposal (PDF, Word or text, up to 10 MB).",
      read: "Read milestones",
      too_big: "The file is over 10 MB",
      failed: "Contract: %{error}",
      nothing: "No milestones or invoices found in this file",
      review_help:
        "AI read these from the contract. Check and edit them; nothing is saved until you click Save. Not started and Completed stay first and last.",
      milestone: "Milestone",
      add_invoice: "Add invoice",
      create_delivery: "Create the delivery for this deal",
      no_delivery: "This deal has no delivery yet",
      save: "Save milestones and invoices",
      saved: "Milestones and draft invoices saved",
      sales_cannot_save:
        "Only an admin or the delivery team can save milestones and invoices.",
    },
    ithnk_suppressions: {
      name: "Do not contact",
      help: "People and companies who asked not to be contacted. Lead searches and imports skip them, and their pages show a red badge. Add an email, a domain or a website.",
      fields: { value: "Email or domain", reason: "Reason (optional)" },
      value_placeholder: "jane@acme.com or acme.com",
      kinds: { email: "Email", domain: "Domain" },
      sources: {
        manual: "Added by hand",
        unsubscribe: "Unsubscribe reply",
        import: "Import",
      },
      badge: "Do not contact",
      badge_help: "On the do-not-contact list (Settings)",
      invalid: "Type an email address, a domain or a website",
      already: "Already on the do-not-contact list",
      empty: "Nobody is on the list yet.",
      skipped_import: "On the do-not-contact list",
    },
    invoices: {
      name: "Invoice |||| Invoices",
      fields: {
        number: "Number",
        deal_id: "Deal",
        company_id: "Company",
        issue_date: "Issue date",
        due_date: "Due date",
        amount: "Amount",
        currency: "Currency",
        amount_paid: "Amount paid",
        status: "Status",
        notes: "Notes",
        collected_by: "Collected by",
        milestone_id: "Milestone",
      },
      statuses: {
        draft: "Draft",
        sent: "Sent",
        partially_paid: "Partially paid",
        paid: "Paid",
        cancelled: "Cancelled",
      },
      overdue: "Overdue",
      overdue_list: "Overdue invoices",
      no_milestone: "No milestone",
      board: "Board",
      list: "List",
    },
  },
};
